import React, { useEffect, useState, useLayoutEffect } from "react";
import { Link } from 'react-router-dom';
import { Box } from "@material-ui/core";
import { viewFileAction } from "../redux/actions/CustomerAction";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import ExcelImage from "../ExcelLarge.png";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { gridFocusColumnHeaderSelector } from "@material-ui/data-grid";
import parse from 'html-react-parser';
export default function ErrorComponent({ error }) {
    
    const [errorList, setErrorList] = useState([]);
    const temp = [];
    useEffect(() => {
        let index = 1;
        for (var k in error) {
            if (error.hasOwnProperty(k)) {
               
                Array.from(error[k]).forEach((value) => {
                    temp.push(parse(`<div style="color:red;font-weight:bold" key="${index}">` + `${value}` + `</div><br/>`));
                    index++;
                })
            }
        }

        setErrorList(...errorList, temp);
    }, [])


    return (
        <div style={{display:"flex",flexDirection:'column'}}> {errorList}   
        </div>
    );
}
